// tslint:disable:jsx-no-multiline-js
import * as React from 'react';

import * as CommonUx from '@abb/common-ux';

interface IFooterProps {
  isLastStep: boolean;
  isFirstStep: boolean;
  isValid: boolean;
  onClickCancel: () => void;
  onClickBack: () => void;
  onClickNext: () => void;
  onClickSubmit: () => void;
}
export const Footer: React.SFC<IFooterProps> = (props: IFooterProps) => {
  return (
    <div className='row'>
      <div className='col-sm-12'>
        <CommonUx.Button
          buttonType='discrete'
          buttonSize='default'
          className='custom-button blue-font'
          onClick={props.onClickCancel}>Cancel</CommonUx.Button>
        {!props.isFirstStep && <CommonUx.Button
          buttonType='discrete'
          buttonSize='default'
          className='custom-button blue-font'
          onClick={props.onClickBack}>Back</CommonUx.Button>
        }
        {!props.isLastStep && <CommonUx.Button
          buttonType={props.isValid ? 'primary' : 'normal'}
          buttonSize='default'
          className={props.isValid ? 'custom-button' : 'custom-button inactive-button'}
          onClick={props.onClickNext}>Next</CommonUx.Button>
        }
        {props.isLastStep && <CommonUx.Button
          buttonType={props.isValid ? 'primary' : 'normal'}
          buttonSize='default'
          className={props.isValid ? 'custom-button' : 'custom-button inactive-button'}
          onClick={props.onClickSubmit}>Submit</CommonUx.Button>
        }
      </div>
    </div>
  );
};
